import React from "react";

import Carousel from "features/new/carousel";

import "features/new/experience/view.scss";

const ExperienceView = () => (
  <section className="main__experience">
    <div className="experience__container">
      <h2 className="experience__headline">
        The Community
        {/*Parlor Experience*/}
      </h2>
      <p className="experience__description">
        We have cultivated a diverse community of social, driven and well
        rounded individuals. Parlor values open-mindedness, intellectual
        curiosity and appreciates high quality in everything that we do. Members
        have the option to join a range of groups that foster more focused
        interactions within the larger Parlor community.
      </p>
    </div>
    <Carousel />
  </section>
);

export default ExperienceView;
